import OrdersGridView from "views/home/orders/OrdersGridView";

const OrdersTab = ({ userId }: { userId: string }) => {
  return <OrdersGridView userId={userId} columnsToHide={["applicantName", "courseName"]} />;
};

export default OrdersTab;
